var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hint-label"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('span',{staticClass:"hint-label-btn"},[_c('ico',{attrs:{"name":"icoCancel","size":"16","color":"#79919C"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }